import { axiosApi } from 'app/api/api';
import {
  SortingValue,
  sortApiMap,
} from 'shared/lib/components/controls/sorting/sortingControl';
import { SearchResultData } from 'entities/searchResult/model/searchResultModel';
import { SearchResultsResponse } from 'app/store/lib/searchStore';

export const searchApi = {
  getByEntityResult: async (params: {
    search: string;
    sort: SortingValue;
    folderId?: string | null;
    sectionId?: string | null;
    search_exact: boolean;
  }) => {
    const res = await axiosApi.post<SearchResultsResponse>(`/search/relevant`, {
      search_word: params.search,
      search_exact: params.search_exact,
      entity_id: params.folderId || params.sectionId,
      ...sortApiMap[params.sort],
    });

    return res.data;
  },

  getCommonResults: async (
    search: string,
    sort: SortingValue,
    search_exact: boolean
  ) => {
    const res = await axiosApi.post<SearchResultData[]>(`/search/`, {
      search_word: search,
      search_exact: search_exact,
      ...sortApiMap[sort],
    });

    return { other_results: res.data } as SearchResultsResponse;
  },
};
